import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject, Observable } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class AboutpageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  aboutData: any;

  private aboutHeroSubject$ = new BehaviorSubject<any>(null);
  public aboutHero$ = this.aboutHeroSubject$.asObservable();
  private aboutCustomersSubject$ = new BehaviorSubject<any>(null);
  public aboutCustomers$ = this.aboutCustomersSubject$.asObservable();
  private aboutOverviewSubject$ = new BehaviorSubject<any>(null);
  public aboutOverview$ = this.aboutOverviewSubject$.asObservable();
  private aboutOverview1Subject$ = new BehaviorSubject<any>(null);
  public aboutOverview1$ = this.aboutOverview1Subject$.asObservable();
  private aboutOverview2Subject$ = new BehaviorSubject<any>(null);
  public aboutOverview2$ = this.aboutOverview2Subject$.asObservable();
  private aboutValuesSubject$ = new BehaviorSubject<any>(null);
  public aboutValues$ = this.aboutValuesSubject$.asObservable();
  private aboutTeamSubject$ = new BehaviorSubject<any>(null);
  public aboutTeam$ = this.aboutTeamSubject$.asObservable();
  private aboutOverview3Subject$ = new BehaviorSubject<any>(null);
  public aboutOverview3$ = this.aboutOverview3Subject$.asObservable();
  private aboutLeaderSubject$ = new BehaviorSubject<any>(null);
  public aboutLeader$ = this.aboutLeaderSubject$.asObservable();
  private aboutInvestorSubject$ = new BehaviorSubject<any>(null);
  public aboutInvestor$ = this.aboutInvestorSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  getAboutPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.companyPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.aboutData = mod.filter(x => x.fields?.['id'] == PageId.companyAbout);
        const heroData = this.aboutData[0]?.fields?.heroContentPanel.fields;
        if (heroData) {
          this.aboutHeroSubject$.next(heroData);
        }
        const customersData =
          this.aboutData[0]?.fields?.customersStatsContentPanel.fields;
        if (customersData) {
          this.aboutCustomersSubject$.next(customersData);
        }
        const teamData = this.aboutData[0]?.fields?.team?.fields;
        if (teamData) {
          this.aboutTeamSubject$.next(teamData);
        }
        const teamOverviewData = this.aboutData[0]?.fields?.teamOverview;
        if (teamOverviewData) {
          this.aboutOverviewSubject$.next(teamOverviewData);
        }
        const teamOverview1Data =
          this.aboutData[0]?.fields?.teamOverview[0].fields;
        if (teamOverview1Data) {
          this.aboutOverview1Subject$.next(teamOverview1Data);
        }
        // const teamOverview2Data = this.aboutData[0]?.fields?.teamOverview[1].fields;
        // if (teamOverview2Data) {
        //   this.aboutOverview2Subject$.next(teamOverview2Data);
        // }
        const valuesData = this.aboutData[0]?.fields?.values?.fields;
        if (valuesData) {
          this.aboutValuesSubject$.next(valuesData);
        }
        const teamOverview3Data =
          this.aboutData[0]?.fields?.teamOverview[2]?.fields;
        if (teamOverview3Data) {
          this.aboutOverview3Subject$.next(teamOverview3Data);
        }
        // const leaderData = this.aboutData[0]?.fields?.team.fields;
        // if (leaderData) {
        //   this.aboutLeaderSubject$.next(leaderData);
        // }
        const investorData = this.aboutData[0]?.fields?.investor.fields;
        if (investorData) {
          this.aboutInvestorSubject$.next(investorData);
        }
        const getStarted =
          this.aboutData[0]?.fields?.getStartedContentPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }
}
